import { transformCategoryForGTM } from "../transformers.utils";
import { hasProperty, isEmpty } from "../validate";

export function pickDataForFindADealerGTM(values) {
	let dataLayerValues = values;
	return dataLayerValues;
}

export function pictDataForSelectDealerGTM({category, dealer}) {
	let dataLayerValues = {};

	if (!isEmpty(category)) {
		dataLayerValues.category = transformCategoryForGTM(category);
	}

	if (!isEmpty(dealer)) {
		dataLayerValues.dealer = {};

		if (hasProperty(dealer, "address")) {
			dataLayerValues.dealer.address = dealer.address;
		}

		if (hasProperty(dealer, "title")) {
			dataLayerValues.dealer.name = dealer.title;
		}

		if (hasProperty(dealer, "slug")) {
			dataLayerValues.dealer.slug = dealer.slug;
		}
	}

	return dataLayerValues;

}